// extracted by mini-css-extract-plugin
export default {"sierraChatContainer":"SierraChat_sierraChatContainer","loader":"SierraChat_loader"};